import { Translation } from './translation';
import { de } from './de';
import { fr } from './fr';
import { en } from './en';
import { it } from './it';
import { de_residia } from './de_residia';
import { fr_residia } from './fr_residia';
import { en_residia } from './en_residia';
import { it_residia } from './it_residia';
import { fr_fr } from './fr_fr';
import { en_fr } from './en_fr';
import { de_de } from './de_de';
import { en_de } from './en_de';
import { de_at } from './de_at';
import { en_at } from './en_at';

export interface Translations {
  de: Translation;
  fr: Translation;
  it: Translation;
  en: Translation;
}

export const translations: Translations = {
  de: de,
  fr: fr,
  it: it,
  en: en,
};

export const overrideTranslations: { [key: string]: Partial<Translation> } = {
  fr_FR: fr_fr,
  en_FR: en_fr,
  de_DE: de_de,
  en_DE: en_de,
  de_AT: de_at,
  en_AT: en_at,
  de_residia: de_residia,
  en_residia: en_residia,
  fr_residia: fr_residia,
  it_residia: it_residia,
};
